//@ts-nocheck

import styled from "styled-components";

interface SectionProps {
  withBackground?: boolean
  colorScheme?: string
}

export const Section = styled.section<SectionProps>`
  padding-top: ${({ theme, ignoreHorizontalPadding }) => ignoreHorizontalPadding ? theme.rem(0) : theme.rem(32)};
  padding-bottom: ${({ theme, ignoreHorizontalPadding }) => ignoreHorizontalPadding ? theme.rem(0) : theme.rem(32)};
  background-color: ${({ withBackground, theme, colorScheme }) => withBackground ? theme.colorScheme[colorScheme].surface.outside : 'transparent'};

  &.without-background + &.without-background {
    border-top: 1px solid #EEE;

    ${({ theme }) => theme.mediaQuery.xl(`
      border-top: none;
    `)}
  }

  &:has([data-view-state="results"]) {
    background-color: transparent;
  }

  ${({ theme, ignoreHorizontalPadding }) => theme.mediaQuery.lg(`
    padding-top: ${ignoreHorizontalPadding ? theme.rem(0) : theme.rem(60)}; 
    padding-bottom: ${ignoreHorizontalPadding ? theme.rem(0) : theme.rem(60)};
    border-top: none;
    border-bottom: none;
  `)}
`